import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export const DefineInfoSystem = new Vuex.Store({
  state: {
    Model:{
        SysVersion: "",
        Dbversio: "",
        TblSoftwareId:1,
        Dbname: "",
        SystemName: "",
        ZamanInsert: "",
        TblUserGrpIdInsert: 1,
        ZamanLastEdit: "",
        TblUserGrpIdLastEdit: 1,
        LogDbname: "",
        ImageDbname: "",
        Tajmie: true,
        WebDbname: "",
        DashboardUrl: "",
        FromAutoNightJob: "",
        ToAutoNightJob: "",
        HarAutoNightJob: 24,
        FromAutoReIndex: "",
        ToAutoReIndex: "",
    },

  },
  mutations: {},
  actions: {},
  getters: {},
});
